<script lang="ts" setup>
    import type { SearchItem } from 'vue-instantsearch/vue3/es';

    interface AlgoliaRefinementItemProps {
        item: SearchItem;
        refine: (value: string) => void;
        createURL: (item: SearchItem) => string;
        isColors?: boolean;
        getValueWithPostfix: (value: string) => string;
        attribute: string;
    }

    defineProps<AlgoliaRefinementItemProps>();

    const color = (value: string) => {
        const colorName = value.trim().toLowerCase().replace(/\s+/g, '-');
        return `color-${colorName}`;
    };
</script>
<template>
    <a
        :href="createURL(item)"
        :data-insights-filter="`${attribute}:${item.value}`"
        @click.prevent="refine(item.value)"
        class="atm-algolia-refinement-list-item group flex w-full items-center justify-between gap-3">
        <span class="flex items-center gap-3">
            <span
                aria-hidden="true"
                :class="[
                    'relative size-4.5 shrink-0 rounded-xs border-2 border-woom-black bg-transparent transition-all before:absolute before:top-1/2 before:left-1/2 before:block before:size-10 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full before:bg-transparent before:opacity-0 before:transition-opacity group-hover:before:bg-woom-black group-hover:before:opacity-10',
                    { ' bg-woom-black': item.isRefined },
                ]">
                <svg
                    :class="[
                        'absolute size-4.5 -translate-x-0.5 -translate-y-0.5 stroke-white stroke-3 opacity-0 transition-opacity',
                        { 'opacity-100': item.isRefined },
                    ]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
            </span>
            {{ getValueWithPostfix(item.label) }}
            <span class="text-woom-grey-taupe">({{ item.count }})</span>
        </span>
        <span
            v-if="isColors"
            :class="['block size-4 rounded-full', color(item.value)]"></span>
    </a>
</template>
